import { useBreakpoint } from '../providers';
import { useMapContext } from '../hooks/MapProvider';
import styled from 'styled-components6';
import { Else, If, Then } from 'react-if';
import { H2, H3, mqDown } from 'rwl-ui';
import { useGlobal } from '../hooks';

const TitleContainer = styled.div<{
    isBumpOutEnabled?: boolean;
}>`
    display: flex;
    justify-content: center;
    margin: var(--rwl-spacing-sm);
    ${mqDown('sm')} {
        justify-content: flex-start;
        padding-left: var(--rwl-spacing-lg);
        padding-right: var(--rwl-spacing-lg);
    }
    ${({ isBumpOutEnabled }) =>
        isBumpOutEnabled &&
        `${mqDown('sm')} {
            margin-right: 20%; /* Make room for close button on small screens */
            }`}
`;

export const Title = (): JSX.Element => {
    const { bumpOutTestEnabled } = useGlobal();
    const { isBelowBreakpoint } = useBreakpoint();
    const { serviceAreas } = useMapContext();
    const totalJobs = serviceAreas.reduce(
        (acc, serviceArea) => acc + serviceArea.jobCount,
        0
    );
    if (totalJobs === 0) return <></>;

    return (
        <TitleContainer isBumpOutEnabled={bumpOutTestEnabled}>
            <If condition={isBelowBreakpoint('sm')}>
                <Then>
                    <H3
                        style={{ margin: 0 }}
                        className="rwl-neighborhood-header"
                    >
                        Check out our work in your neighborhood
                    </H3>
                </Then>
                <Else>
                    <H2
                        style={{ margin: 0 }}
                        className="rwl-neighborhood-header"
                    >
                        Check out our work in your neighborhood
                    </H2>
                </Else>
            </If>
        </TitleContainer>
    );
};
